// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GSfx2RSqqDFDzVPyVw32 {
    width: 30%;
    padding-top: 32px;
}

.GSfx2RSqqDFDzVPyVw32 header {
    padding: 0 16px 16px;
    border-bottom: 1px solid #E5E5E5;
}

.LNeOj1mG4ELFJgTH_vxb {
    display: flex;
    flex-direction: row;
}

.pYi9iIr5kI7azm_XPndz {
    margin: 0;
    font-weight: 500;
    font-size: 20px;
    text-align: center;
}

.sWoFHYBjXAO0b9SD_UOh {
    margin: 0;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    text-align: center;
}

.WUqfuvR6cvigmXoRAjjg {
    width: 10%;
    transition: .3s;
}

.WUqfuvR6cvigmXoRAjjg svg {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

.WUqfuvR6cvigmXoRAjjg:hover svg {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.x8innk5nNRDOxfVxn7C3 {
    width: 80%;
}

.S1EF1l0GSGpXsvY5UZ6n {
    display: flex;
    justify-content: space-between;
    column-gap: 16px;

    margin-top: 16px;
    margin-bottom: 16px;
}

.yDE1QJ_7_QNcAGD9h25Q p {
    margin: 0;
}

.a7GizADQbzflyKpvoB99 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    font-size: 14px;
}

.kNJcARJ672zw7qM2OWie {
    width: 100%;
}

.rJnMzpbMXqSk2m1VuvPt, .rJnMzpbMXqSk2m1VuvPt span, .NcjnYb5YZRBb59evSmf8 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
    font-size: 11px !important;
}

.NcjnYb5YZRBb59evSmf8 {
    margin-right: 4px;
}

.FzStwpUWKMGhK2HSuVWo {
    padding: 1rem;
}

@media screen and (max-width: 768px) {
    .GSfx2RSqqDFDzVPyVw32 {
        padding: 0 32px 32px;
    }

    .I6oJsVm8a1hgMnyznEW0 {
        background-color: white;
        border-radius: 5px;
    }

    .I6oJsVm8a1hgMnyznEW0 header {
        padding-top: 16px;
    }
}

@media screen and (max-width: 425px) {
    .GSfx2RSqqDFDzVPyVw32 {
        padding: 0 16px 16px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardWallet/DashboardWalletSociety/DashboardWalletSociety.module.css"],"names":[],"mappings":"AAGA;IACI,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,mDAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,mDAAwB;AAC5B;;AAEA;IACI,mDAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;;IAEhB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mDAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mDAAwB;IACxB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,uBAAuB;QACvB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["@value colors: \"../../../../components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-text-subtle from colors;\n\n.wallet {\n    width: 30%;\n    padding-top: 32px;\n}\n\n.wallet header {\n    padding: 0 16px 16px;\n    border-bottom: 1px solid #E5E5E5;\n}\n\n.header {\n    display: flex;\n    flex-direction: row;\n}\n\n.society {\n    margin: 0;\n    font-weight: 500;\n    font-size: 20px;\n    text-align: center;\n}\n\n.update {\n    margin: 0;\n    color: color-text-subtle;\n    text-align: center;\n}\n\n.back {\n    width: 10%;\n    transition: .3s;\n}\n\n.back svg {\n    color: color-text-subtle;\n}\n\n.back:hover svg {\n    color: color-purple;\n}\n\n.title {\n    width: 80%;\n}\n\n.shares {\n    display: flex;\n    justify-content: space-between;\n    column-gap: 16px;\n\n    margin-top: 16px;\n    margin-bottom: 16px;\n}\n\n.info p {\n    margin: 0;\n}\n\n.label {\n    color: color-text-subtle;\n    font-size: 14px;\n}\n\n.postinvest {\n    width: 100%;\n}\n\n.hint, .hint span, .icon {\n    color: color-text-subtle;\n    font-size: 11px !important;\n}\n\n.icon {\n    margin-right: 4px;\n}\n\n.content {\n    padding: 1rem;\n}\n\n@media screen and (max-width: 768px) {\n    .wallet {\n        padding: 0 32px 32px;\n    }\n\n    .container {\n        background-color: white;\n        border-radius: 5px;\n    }\n\n    .container header {\n        padding-top: 16px;\n    }\n}\n\n@media screen and (max-width: 425px) {\n    .wallet {\n        padding: 0 16px 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../../../components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"wallet": `GSfx2RSqqDFDzVPyVw32`,
	"header": `LNeOj1mG4ELFJgTH_vxb`,
	"society": `pYi9iIr5kI7azm_XPndz`,
	"update": `sWoFHYBjXAO0b9SD_UOh`,
	"back": `WUqfuvR6cvigmXoRAjjg`,
	"title": `x8innk5nNRDOxfVxn7C3`,
	"shares": `S1EF1l0GSGpXsvY5UZ6n`,
	"info": `yDE1QJ_7_QNcAGD9h25Q`,
	"label": `a7GizADQbzflyKpvoB99`,
	"postinvest": `kNJcARJ672zw7qM2OWie`,
	"hint": `rJnMzpbMXqSk2m1VuvPt`,
	"icon": `NcjnYb5YZRBb59evSmf8`,
	"content": `FzStwpUWKMGhK2HSuVWo`,
	"container": `I6oJsVm8a1hgMnyznEW0`
};
export default ___CSS_LOADER_EXPORT___;
